/**
 * 步骤条demo
 * @description 结合WizCustomSteps的demo，新增了其他步骤条的demo
 * @author mll
 * @date 2020-3-11
 */
import React from "react";
import { connect } from "dva";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import classnames from "classnames";
const {
    WizCustomSteps,
    WizButton,
    WizCard,
    WizCommonSteps,
    WizIcon,
} = component_tool;
const { WizContainer } = framework_tool;

class Steps extends WizContainer {

    componentName = "StepsDemo";

    state = {
        current: 0
    }

    /**
     * WizCustomSteps demo
     */
    _customSteps = () => {
        const { current } = this.state

        const header = [{
            title: '课程信息'
        },
        {
            title: '课程内容'
        }]

        let showContent = (current) => {
            switch (current) {
                case 0:
                    return <div style={{ width:1500, padding:50, backgroundColor:'#eee' }}>123</div>
                case 1:
                    return '456'
            }
        }

        const wizCustomStepsProps = {
            header,
            current,
            content: showContent(current),
            footer: <WizButton type="primary" onClick={
                () => {
                    const { current } = this.state

                    current < header.length - 1 ?
                        this.setState({
                            current: current + 1
                        })
                        :
                        this.setState({
                            current: header.length - 1
                        })
                }
            }> 保存并进入下一步 </WizButton>
        }

        return (
            <WizCard title='WizCustomSteps' icon={0}>
                <WizCustomSteps {...wizCustomStepsProps} />
            </WizCard>
        )
    }

    _convertColor(name){
        let b = 1
		for (let index = 0; index < name.length; index++) {
            b= b*name.charCodeAt(index)%16777216
            
        }
        let ab = (b/65535^0)%255
        let bc = (b/255^0)%255
        let cd = ~~b%255
        log.info(`xasdasd`,`#${ab.toString(16)}${bc.toString(16)}${cd.toString(16)}`)
        return `#${ab.toString(16)}${bc.toString(16)}${cd.toString(16)}`
    }
    _commonSteps = () => {
        
        let cardProps = {
            title: '已安排内容 （4）',
            icon: 'solution',
            headStyle: { backgroundColor: '#f8f8f8', color: '#3a3a3a' },
            extra: <WizButton type="primary"><WizIcon type="sort-ascending" />调整顺序</WizButton>
        }
        let stepsProps = {
            style: { paddingTop: 50 }
        }
        let stepProps = {
        }
        let datas = [
            { title: '直播课堂' },
            { title: '签到' },
            { title: '考试' },
            { title: '问卷' },
        ]
        let renderItem = (data, index, datas, callback) => {
            if (index % 2 == 0) {
                callback({
                    dot: <WizIcon type="info-circle" theme="twoTone" twoToneColor={this._convertColor(data['title'])} style={{ fontSize: '30px' }} />
                })
            } else {
                callback({
                    dot: <WizIcon type="info-circle" theme="twoTone" twoToneColor={this._convertColor(data['title'])} style={{ fontSize: '30px' }} />
                })
            }
            return (
                <div
                    style={{
                        height: 100,
                        width: 200,
                        backgroundColor: 'skyblue',
                        position: 'relative',
                        top: -34,
                        marginLeft: 10
                    }}
                >{data['title']}</div>
            )
        }

        return (
            <WizCard title='WizCommonSteps' icon={0}>
                <WizCommonSteps
                    timelineProps={stepsProps}
                    itemProps={stepProps}
                    cardProps={cardProps}
                    datas={datas}
                    renderItem={renderItem}
                />
            </WizCard>
        )
    }

    _render() {
        let r = []
        r.push(this._customSteps())
        r.push(this._commonSteps())
        return r
    }
}

const mapStateToProps = (state, ownProps) => { };

export default connect(mapStateToProps)(Steps);